<template>
  <p class="ques-title-inner" v-if="ques.firstFlag === 'under'">
    <span v-for="i in ques.underArr.length" :key="i">
      <input
        class="textMultiple"
        type="text"
        @change="handleInput"
        @blur.capture="blur"
        v-model="ques.blankSetting[i - 1].value"
        :style="{ width: calcWidth(ques.underArr[i - 1]) }"
      />
      <p class="text-title" v-html="ques.textArr[i - 1]"></p>
    </span>
  </p>
  <p class="ques-title-inner" v-else>
    <span
      v-for="i in ques.textArr.length"
      :data-id="i"
      :key="i"
      style="display: block"
    >
      <p class="text-title" v-html="ques.textArr[i - 1]"></p>
      <input
        type="text"
        class="textMultiple"
        @change="handleInput"
        @blur.capture="blur"
        v-if="ques.underArr[i - 1]"
        v-model="ques.blankSetting[i - 1].value"
        :style="{ width: calcWidth(ques.underArr[i - 1]) }"
      />
    </span>
  </p>
</template>

<script>
export default {
  name: 'text-multiple',
  data() {
    return {}
  },
  props: ['ques'],
  methods: {
    calcWidth(str) {
      return Math.floor(str.length * 8.9) + 'px'
    },
    handleInput() {
      for (let i = 0; i < this.ques.blankSetting.length; i++) {
        if (this.ques.blankSetting[i].value === '') {
          this.$emit('unfinish')
          return
        }
      }
      this.$emit('finish')
    },
    removeLables(html) {
      if (!html) return ''
      return html.replace(/<\/?.+?>/g, '')
    },
    blur() {
      window.parent.postMessage({ isblur: true }, '*')
    }
  }
}
</script>
<style lang="scss" scoped>
.ques-title-inner {
  max-width: calc(100% - 60px);
  .textMultiple {
    max-width: 100%;
  }
}
.text-title {
  display: inline-block;
  p {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/textMultiple.vue